import { TeacherMetricsEffects } from "./teacher-metrics.effect";
import { CoursesEffects } from "./teacher-classes.effect";
import { ActiveLanguagesEffects } from "./active-languages.effect";
import { StudentsEffects } from "./students.effect";
import { SchoolsEffects } from "./schools.effect";
import { AssignmentsEffects } from "./assignments.effect";
import { AssignmentsStudentsEffects } from "./assignments-students.effect";
import { GradesEffects } from "./grades.effect";
import { ActiveSubjectsEffects } from "./active-subjects.effects";
import { ActiveEditionsEffects } from "./active-editions.effects";

// so we can just have one import in teacher-classes.module
export const effects: any[] = [
    ActiveLanguagesEffects,
    ActiveSubjectsEffects,
    ActiveEditionsEffects,
    AssignmentsEffects,
    AssignmentsStudentsEffects,
    CoursesEffects,
    GradesEffects,
    StudentsEffects,
    SchoolsEffects,
    TeacherMetricsEffects,
];

export * from "./teacher-metrics.effect";
export * from "./teacher-classes.effect";
export * from "./active-languages.effect";
export * from "./students.effect";
export * from "./schools.effect";
export * from "./assignments.effect";
export * from "./assignments-students.effect";
export * from "./grades.effect";
export * from "./active-subjects.effects";
export * from "./active-editions.effects";
